import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import RankingSection from './components/RankingSection';
import HotMangaGrid from './components/HotMangaGrid';
import LatestUpdates from './components/LatestUpdates';

export default function Home() {
  return (
    <>
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'YY漫画网 - 韩漫日漫国漫大全',
          description: 'YY漫画网提供韩漫、日漫、国漫等分类大全，好看的漫画排行榜推荐，免费漫画分类浏览，全集漫画免费下拉式阅读，热门漫画追更在线看。',
          url: 'https://yymanhua.com',
          inLanguage: 'zh-CN',
          isPartOf: {
            '@type': 'WebSite',
            name: 'YY漫画网',
            url: 'https://yymanhua.com',
          },
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: '首页',
                item: 'https://yymanhua.com',
              },
            ],
          },
        }}
      />
      <Navbar />
      <main>
        <HeroBanner />
        <CategoryNav />
        <HotMangaGrid />
        <RankingSection />
        <LatestUpdates />
      </main>
      <Footer />
    </>
  );
}